export enum AnalyticsSeverity {
	CRITICAL = 'CRITICAL',
	MAJOR = 'MAJOR',
	MINOR = 'MINOR',
}
